import { ChatsStates, ChatState, ChatTypes } from "./types";

export interface ChatsState {
  authChatsUnsubscribe: (() => void) | null;
  initialLoadCompleted: boolean;
  chatsFilter: string;
  selectedChat?: string | ChatTypes.NEW_CHAT_TYPE | null;
  selectedMessageIds?: string[];
  futureSelectedChatId?: string;
  chatIds: string[];
  allChatIds: string[];
  remainingChatIds: string[];
  chats: ChatsStates;
  sharedMessage?: string;
  sharedImages?: string[];
  messageReactionId: string | null;
}

export const chatsState: ChatsState = {
  authChatsUnsubscribe: null,
  initialLoadCompleted: false,
  chatsFilter: "",
  chatIds: [],
  allChatIds: [],
  remainingChatIds: [],
  chats: {},
  sharedMessage: "",
  sharedImages: [],
  messageReactionId: null,
};

export type ChatGetterHandler = (chatId: string) => ChatState | null;
